const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFileAdd(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "32px",
    height: "32px",
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "file_add_svg__linear0",
    gradientUnits: "userSpaceOnUse",
    x1: 140.64,
    y1: 275.45,
    x2: 294.63,
    y2: 275.45,
    gradientTransform: "matrix(0.0744186,0,0,0.0744186,0,0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "rgb(27.45098%,56.470588%,100%)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "rgb(17.254902%,83.137255%,94.901961%)",
      stopOpacity: 1
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "file_add_svg__surface1"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "url(#file_add_svg__linear0)"
    },
    d: "M 20.996094 19.570312 L 17.125 19.570312 L 17.125 15.695312 C 17.125 15.183594 16.707031 14.769531 16.195312 14.769531 C 15.683594 14.769531 15.269531 15.1875 15.269531 15.695312 L 15.269531 19.570312 L 11.394531 19.570312 C 10.882812 19.570312 10.464844 19.988281 10.464844 20.5 C 10.464844 21.011719 10.882812 21.425781 11.394531 21.425781 L 15.269531 21.425781 L 15.269531 25.300781 C 15.269531 25.8125 15.683594 26.230469 16.195312 26.230469 C 16.707031 26.230469 17.125 25.8125 17.125 25.300781 L 17.125 21.425781 L 20.996094 21.425781 C 21.507812 21.425781 21.925781 21.011719 21.925781 20.5 C 21.925781 19.988281 21.507812 19.570312 20.996094 19.570312 Z M 20.996094 19.570312 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(96.862745%,96.862745%,96.862745%)",
      fillOpacity: 1
    },
    d: "M 7.996094 28.851562 C 7.753906 28.851562 7.515625 28.753906 7.339844 28.582031 C 7.167969 28.410156 7.070312 28.167969 7.070312 27.925781 L 7.070312 3.980469 C 7.070312 3.734375 7.167969 3.496094 7.34375 3.324219 C 7.515625 3.148438 7.753906 3.050781 8 3.050781 L 19.535156 3.050781 C 19.777344 3.050781 20.015625 3.148438 20.191406 3.324219 L 24.605469 7.738281 C 24.777344 7.914062 24.878906 8.152344 24.878906 8.394531 L 24.878906 27.925781 C 24.878906 28.167969 24.777344 28.410156 24.605469 28.582031 C 24.433594 28.753906 24.195312 28.851562 23.949219 28.851562 Z M 23.019531 26.996094 L 23.019531 8.78125 L 19.148438 4.90625 L 8.925781 4.90625 L 8.925781 26.996094 Z M 23.019531 26.996094 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(96.862745%,96.862745%,96.862745%)",
      fillOpacity: 1
    },
    d: "M 23.949219 27.925781 L 23.949219 27.441406 L 8.480469 27.441406 L 8.480469 4.460938 L 19.332031 4.460938 C 19.332031 4.460938 21.402344 6.527344 21.402344 6.527344 L 23.46875 8.59375 L 23.46875 27.925781 L 23.949219 27.925781 L 23.949219 27.441406 L 23.949219 27.925781 L 24.429688 27.925781 L 24.429688 8.394531 C 24.429688 8.269531 24.378906 8.144531 24.289062 8.054688 L 19.875 3.640625 C 19.785156 3.550781 19.660156 3.496094 19.535156 3.496094 L 8 3.496094 C 7.871094 3.496094 7.746094 3.550781 7.65625 3.640625 C 7.566406 3.730469 7.515625 3.851562 7.515625 3.980469 L 7.515625 27.925781 C 7.515625 28.050781 7.566406 28.175781 7.65625 28.265625 C 7.746094 28.355469 7.871094 28.40625 8 28.40625 L 23.949219 28.40625 C 24.078125 28.40625 24.199219 28.355469 24.289062 28.265625 C 24.382812 28.175781 24.433594 28.050781 24.433594 27.925781 Z M 23.949219 27.925781 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(96.862745%,96.862745%,96.862745%)",
      fillOpacity: 1
    },
    d: "M 19.5625 9.164062 C 19.320312 9.164062 19.078125 9.066406 18.90625 8.894531 C 18.734375 8.722656 18.632812 8.480469 18.632812 8.238281 L 18.632812 4.117188 C 18.632812 3.601562 19.050781 3.1875 19.5625 3.1875 C 20.074219 3.1875 20.492188 3.605469 20.492188 4.117188 L 20.492188 7.308594 L 23.160156 7.308594 C 23.671875 7.308594 24.089844 7.726562 24.089844 8.238281 C 24.089844 8.746094 23.671875 9.164062 23.160156 9.164062 Z M 19.5625 9.164062 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(96.862745%,96.862745%,96.862745%)",
      fillOpacity: 1
    },
    d: "M 23.160156 7.753906 L 19.5625 7.753906 L 19.5625 8.238281 L 20.042969 8.238281 L 20.042969 4.113281 C 20.042969 3.847656 19.828125 3.632812 19.5625 3.632812 C 19.296875 3.632812 19.082031 3.847656 19.082031 4.113281 C 19.082031 6.570312 19.082031 8.238281 19.082031 8.238281 C 19.082031 8.363281 19.132812 8.488281 19.222656 8.578125 C 19.3125 8.667969 19.4375 8.71875 19.5625 8.71875 L 23.160156 8.71875 C 23.425781 8.71875 23.644531 8.503906 23.644531 8.238281 C 23.644531 7.96875 23.425781 7.753906 23.160156 7.753906 Z M 23.160156 7.753906 "
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFileAdd);
export default __webpack_public_path__ + "static/media/file_add.50899efcea98a21a8e1f477c7bcd0a45.svg";
export { ForwardRef as ReactComponent };